// El nombre de la cadena del scope RBAC del usuario, para mostrarla fija; `null` si no tiene una sola.
import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { displayNameOrShort } from '@/lib/displayName';
import { resolveInventoryRetailer } from '@/domains/retail/admin/inventario/lib/inventoryRetailer';

export function useOwnRetailerName(): string | null {
    const { roleAssignments } = useAuth();
    return useMemo(() => {
        const { retailerId } = resolveInventoryRetailer(roleAssignments);
        if (retailerId === null) return null;
        const assignment = roleAssignments.find(
            (candidate) => candidate.scope === 'LEVEL_1' && candidate.scopeRef === retailerId,
        );
        return displayNameOrShort(assignment?.scopeRefName, retailerId);
    }, [roleAssignments]);
}
